"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Header = _styledComponents["default"].header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: #ffffff;\n    box-shadow: ", ";\n"])), function (props) {
  return props.theme.admin.colors.brandDark;
}, function (props) {
  return props.theme.admin.boxShadow;
});

var _default = Header;
exports["default"] = _default;